import { render } from "./PlayerVideoJs.vue?vue&type=template&id=bc5b0ea4&scoped=true"
import script from "./PlayerVideoJs.vue?vue&type=script&lang=js"
export * from "./PlayerVideoJs.vue?vue&type=script&lang=js"

import "./PlayerVideoJs.vue?vue&type=style&index=0&id=bc5b0ea4&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5b0ea4"]])

export default __exports__